<div class="modal-header">
  <h4 class="modal-title pull-left">Create Location</h4>
  <button
    type="button"
    class="btn-close close pull-right"
    aria-label="Close"
    (click)="bsModalRef.hide()"
  >
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="createForm">
    <div class="row">
      <div class="col-6">
        <form [formGroup]="createForm" autocomplete="off">
          <div class="row pb-2">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Name</mat-label>
              <input matInput formControlName="name" placeholder="Enter name" />
            </mat-form-field>
          </div>

          <div class="row row-spacer">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Name2</mat-label>
              <input
                matInput
                formControlName="name2"
                placeholder="Enter name2"
              />
            </mat-form-field>
          </div>

          <div class="row row-spacer">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Street</mat-label>
              <input
                [ngClass]="{
                  'validator-error':
                    createForm.controls['street'].invalid &&
                    createForm.controls['street'].touched
                }"
                required
                matInput
                formControlName="street"
                placeholder="Enter street"
              />
            </mat-form-field>
          </div>

          <div class="row row-spacer">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>AncoPro ID</mat-label>
              <input matInput formControlName="extraInfo" placeholder="Enter AncoPro ID">
            </mat-form-field>
          </div>

          <div class="row row-spacer">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Street2</mat-label>
              <input
                matInput
                formControlName="street2"
                placeholder="Enter street2"
              />
            </mat-form-field>
          </div>

          <div class="row row-spacer">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>House number</mat-label>
              <input
                matInput
                formControlName="houseNumber"
                placeholder="Enter house number"
              />
            </mat-form-field>
          </div>

          <div class="row row-spacer">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Zip</mat-label>
              <input
                required
                [ngClass]="{
                  'validator-error':
                    createForm.controls['zip'].invalid &&
                    createForm.controls['zip'].touched
                }"
                matInput
                formControlName="zip"
                placeholder="Enter zip"
              />
            </mat-form-field>
          </div>

          <div class="row row-spacer">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>City</mat-label>
              <input
                required
                [ngClass]="{
                  'validator-error':
                    createForm.controls['city'].invalid &&
                    createForm.controls['city'].touched
                }"
                matInput
                formControlName="city"
                placeholder="Enter city"
              />
            </mat-form-field>
          </div>

          <div class="row row-spacer">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Country code</mat-label>
              <input
                matInput
                formControlName="countryCode"
                placeholder="Enter country code"
              />
            </mat-form-field>
          </div>

          <div class="row row-spacer">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Country</mat-label>
              <input
                matInput
                formControlName="country"
                placeholder="Enter country"
              />
            </mat-form-field>
          </div>

          <div class="row row-spacer">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Latitude</mat-label>
              <input
                [ngClass]="{
                  'validator-error':
                    createForm.controls['lat'].invalid &&
                    createForm.controls['lat'].touched
                }"
                matInput
                required
                formControlName="lat"
                placeholder="Enter latitude"
                (ngModelChange)="latLngChange()"
              />
            </mat-form-field>
          </div>

          <div class="row row-spacer">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Longtitude</mat-label>
              <input
                [ngClass]="{
                  'validator-error':
                    createForm.controls['lng'].invalid &&
                    createForm.controls['lng'].touched
                }"
                matInput
                required
                formControlName="lng"
                placeholder="Enter longtitude"
                (ngModelChange)="latLngChange()"
              />
            </mat-form-field>
          </div>

          <div class="row row-spacer">
            <mat-form-field class="custom-mat" appearance="outline">
              <mat-label>Type </mat-label>
              <mat-select
                formControlName="locationType"
                style="height: 30px"
                required
              >
                <mat-option
                  *ngFor="let locationType of locationTypes"
                  [value]="locationType.type"
                >
                  {{ locationType.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </form>
      </div>
      <div class="col-6">
        <input
          type="text"
          class="form-control"
          placeholder="Search for location"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="off"
          #search
          [formControl]="searchControl"
          [matAutocomplete]="auto"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          [displayWith]="displayFnAddress"
          (optionSelected)="selectingAutocompleteAddress($event)"
        >
          <mat-option
            *ngFor="let option of displayedSearchInputs"
            [value]="option"
          >
            {{ displayFnAddress(option) }}
          </mat-option>
        </mat-autocomplete>
    
      <google-map
        height="90%"
        width="100%"
        [center]="{ lat: mapPosition?.lat || 0, lng: mapPosition?.lng || 0 }"
        [zoom]="mapPosition?.zoom || 8"
        [options]="mapOptions"
        (mapClick)="mapClickedMarker($event)"
      >
        <map-marker
          *ngIf="marker"
          [position]="{ lat: marker.lat, lng: marker.lng }"
          [options]="markerOptions"
          (mapDragend)="markerDragEnd($event)"
        >
        </map-marker>
      </google-map>
        </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="!createForm.valid"
    (click)="createLocation()"
  >
    Create
  </button>
  <button type="button" class="btn btn-secondary" (click)="bsModalRef.hide()">
    Cancel
  </button>
</div>
